var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{staticClass:"card-map",attrs:{"title":"Google Maps"}},[_c('div',{staticClass:"map"},[_c('div',{attrs:{"id":"map"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }